import {
  Button,
  Checkbox,
  Flex,
  Input,
  Select,
  SelectContent,
  SelectTrigger,
  Text,
} from '@optiaxiom/react';
import { IconTrashCan } from '@optimizely/axiom-icons';

import { Filter, FilterType } from './types';

type FilterItemProps = {
  filter: Filter;
  index: number;
  onChange: (index: number, updates: Partial<Filter>) => void;
  onRemove: (index: number) => void;
};

const FILTER_TYPES = [
  {
    value: FilterType.CONTAINS,
    label: 'Contains',
    description: 'Match if the text contains this value anywhere',
    placeholder: 'Enter text to search for...',
  },
  {
    value: FilterType.STARTS_WITH,
    label: 'Starts With',
    description: 'Match if the text starts with this value',
    placeholder: 'Enter starting text...',
  },
  {
    value: FilterType.ENDS_WITH,
    label: 'Ends With',
    description: 'Match if the text ends with this value',
    placeholder: 'Enter ending text...',
  },
  {
    value: FilterType.EXACT_MATCH,
    label: 'Exact Match',
    description: 'Match only if the text exactly equals this value',
    placeholder: 'Enter exact text...',
  },
  {
    value: FilterType.REGEX,
    label: 'Regular Expression',
    description: 'Match using a regular expression pattern',
    placeholder: 'Enter regex pattern...',
  },
];

const getPlaceholder = (type: FilterType): string => {
  return FILTER_TYPES.find(opt => opt.value === type)?.placeholder || '';
};

export const FilterItem = ({ filter, index, onChange, onRemove }: FilterItemProps) => {
  return (
    <Flex
      flexDirection="row"
      gap="2"
      p="4"
      border="1"
      borderColor="border.default"
      justifyContent="space-between"
      borderR="2"
      alignItems="center"
    >
      <Flex flex="1" alignItems="start" flexDirection="column" gap="6" p="4">
        <Flex flexDirection="row" gap="4" alignItems="center">
          <Select
            value={filter.type}
            onValueChange={(newType: string) => onChange(index, { type: newType as FilterType })}
            options={FILTER_TYPES.map(opt => ({
              label: opt.label,
              value: opt.value,
            }))}
          >
            <SelectTrigger />
            <SelectContent />
          </Select>

          <Input
            value={filter.value}
            onChange={e => onChange(index, { value: e.target.value })}
            placeholder={getPlaceholder(filter.type)}
            style={{ flex: 1 }}
          />
        </Flex>

        <Flex flexDirection="row" flex="1" alignItems="start" gap="2">
          <Checkbox
            checked={filter.case_sensitive}
            onChange={() => onChange(index, { case_sensitive: !filter.case_sensitive })}
          />
          <Text fontSize="sm">Case sensitive</Text>
        </Flex>
      </Flex>

      <Button
        appearance="danger"
        icon={<IconTrashCan />}
        onClick={() => onRemove(index)}
        aria-label="Remove filter"
        size="sm"
      />
    </Flex>
  );
};
